import * as React from 'react';
import { classes, style } from 'typestyle';
const WindowVerticalLayout = ({ className, children, }) => {
    return React.createElement("div", { className: classes(className, verticalLayoutStyle) }, children);
};
export default WindowVerticalLayout;
const verticalLayoutStyle = style({
    display: 'flex',
    flexDirection: 'column',
    padding: 12,
    $nest: {
        '>:not(:first-child)': {
            marginTop: 8,
        },
    },
});
//# sourceMappingURL=WindowVerticalLayout.js.map